import styled from 'styled-components';

export const ListingFiltersWrapper = styled.div`
  margin: 20px 0;
  width: 260px;

  /* custom styles on the checkbox inside the filters */
  .checkbox-title {
    font-size: 14px;
    color: ${({ theme }) => theme.palette.brownishGrey};
    flex: 1;
    height: 100%;

    @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
      width: 100%;
    }
  }
  .checkbox-sub-title {
    color: rgba(99, 99, 99, 0.6);
  }
`;

export const StyledSingleSelectionFilterWrapper = styled.div`
  width: 100%;
  margin: 40px 0;
`;

export const StyledMultiSelectionFilterWrapper = styled.div`
  width: 100%;
  margin-bottom: 40px;
  border-radius: 4px;
`;

export const StyledPriceRangeFilterWrapper = styled.div`
  width: 100%;
  margin-bottom: 40px;
  border-radius: 4px;
`;

export const StyledNameFilterWrapper = styled.div`
  width: 100%;
  padding: 0;
  border-radius: 4px;
  margin-bottom: 40px;

  & .listing-hotel-name-filter {
    margin-top: 15px;
  }
`;
